import { useTranslation } from 'next-i18next';
export const FormLabelLabel = ({
  label,
  isOptional,
  optionalText,
}: {
  label: string;
  isOptional?: boolean;
  optionalText?: string;
}) => {
  const { t } = useTranslation('common');
  return (
    <span className="flex flex-row gap-2">
      <span>
        <label>{label}</label> {optionalText && <p className="text-gray-500">{optionalText}</p>}
      </span>{' '}
      {isOptional && <p className="text-gray-500">({t('optional')})</p>}
    </span>
  );
};
